import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./Registracia.scss";

// prop types
import oAuthUserPropTypes from "../../propTypes/oAuthUserPropTypes";

// components
import withRouter from "../../coraWebComponents/utils/withRouter";
import GoogleButton from "../../coraWebComponents/buttons/GoogleButton";
import Input from "../../coraWebComponents/forms/Input";
import Tooltip from "../../coraWebComponents/forms/Tooltip";
import Button from "../../coraWebComponents/buttons/Button";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import Registration from "../../coraWebComponents/views/registration/Registration";
import Recaptcha from "../Recaptcha";
import ErrorMsg from "../ErrorMsg";
import CookieInfo from "../CookieInfo";

// routes
import Routes from "../../constants/Routes";

// actions
import * as registerActions from "../../actions/registerActions";
import * as oAuthActions from "../../actions/oAuthActions";
import * as verifyActions from "../../actions/verifyActions";

const googleRedirectURI = `${window.config.redirectURI}?provider=1`;
class Registracia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      // menoOdberatela: "Zemanová Anna, Ing.",
      // diskretnyUdaj: "2018004505",
      menoOdberatela: "",
      diskretnyUdaj: "",
      Mobil: "",
      RCTOKEN: "",
      ErrText: "",
      titles: {
        email: `Vložte  Váš  existujúci a platný email. Bude Vašim prihlasovacím menom.`,
        password: `Vložte vaše heslo. Musí obsahovať aspoň 8 znakov, 
          z ktorých aspoň jeden musí byť číslica a aspoň jeden musí byť nealfanumerický znak.`,
        verifyPassword: `Zopakujte opätovne heslo. Musí byť rovnaké ako v predchádzajúcom riadku.`,
        menoOdberatela: `Vložte meno odberateľa, ktorého údaje chcete vidieť. Musí byť zapísané presne v takom tvare, 
          ako je zobrazené na Vašej faktúre. Napr. ‘Mrkvička Jozef, MUDr.`,
        diskretnyUdaj: `Vložte číslo faktúry, ktorým je označená ľubovolná faktúra, ktorá Vám bola doručená pre Vami zadaného odberateľa.`,
        Mobil: `Vložte Váš telefónny kontakt v zobrazenom tvare (buď 0904123456, alebo  +421904123456), 
          ktorý bude slúžiť na riešenie možných problémov pri registrácii.`,
      },
      showRegistrationForm: true,
    };
  }

  handleOnRegister = async (event) => {
    event.preventDefault();
    const { navigate, register } = this.props;

    const { email, password, menoOdberatela, diskretnyUdaj, Mobil, RCTOKEN } =
      this.state;

    if (RCTOKEN === "") {
      this.setState(() => ({ ErrText: "Zaškrtnite položku: Nie som robot!" }));
      return;
    }

    await register(
      {
        email,
        password,
        menoOdberatela,
        diskretnyUdaj,
        Mobil,
        RCTOKEN,
      },
      password === ""
    );

    navigate(Routes.LOGIN);
  };

  verifyEmailAndPass = async ({ email, password }) => {
    await this.props.verifyEmailAndPass({ email, password });

    if (this.props.verifyMessage === "OK") {
      this.setState((state) => ({
        ...state,
        email,
        password,
        showRegistrationForm: false,
      }));
    }
  };

  handleOnNext = async (registrationState) => {
    const { email, password } = registrationState;
    await this.verifyEmailAndPass({ email, password });
  };

  handleOnBack = () => {
    this.setState((state) => ({ ...state, showRegistrationForm: true }));
    this.props.navigate(`${Routes.REGISTRACIA}`, { replace: true });
  };

  handleOnChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleRecaptcha = (token) => {
    this.handleOnChange("RCTOKEN", token);
    this.setState(() => ({ ErrText: "" }));
  };

  handleOnRegisterOAuth = async (code, provider) => {
    const { registerOAuth, navigate } = this.props;
    await registerOAuth(code, googleRedirectURI, provider);

    const { oAuthUser } = this.props;
    if (oAuthUser?.email) {
      this.setState((state) => ({
        ...state,
        email: oAuthUser.email,
        password: "",
        showRegistrationForm: false,
      }));
    }

    navigate(Routes.REGISTRACIA, { replace: true });
  };

  render() {
    const {
      titles,
      menoOdberatela,
      diskretnyUdaj,
      Mobil,
      email,
      showRegistrationForm,
    } = this.state;
    const { isLoading } = this.props;

    if (showRegistrationForm && email !== "") this.setState({ email: "" });


    const media = window.matchMedia('only screen and (min-width: 768px)');
    const className = media ? "col-4 offset-4 p-0 registrationForWeb" : "col registrationForMobile";

    return (
      <>
        {showRegistrationForm ? (
          <Registration
            isLoading={isLoading}
            header={<h1>Registrácia</h1>}
            onSubmit={this.handleOnNext}
            showUsernameInput={false}
            emailValue={email}
            oAuthRegister={this.handleOnRegisterOAuth}
            titles={titles}
            hide={{ username: true }}
            registerButtonLabel="Pokračovať"
          >
            <div className="k-form-field">
              <div className="line">
                <span className="service-label">alebo</span>
              </div>
              <div className="row m-0">
                <GoogleButton
                  redirectURI={googleRedirectURI}
                  state="createUser"
                  primary={false}
                />
              </div>
            </div>

            <div className="k-form-field">
              <div className="footerContainerRegister">
                <a className="login" href={`#${Routes.LOGIN}`}>
                  Prihlásenie
                </a>
              </div>
            </div>
          </Registration>
        ) : (
          <div className="row m-0">
            <div className={className}>
              <div className="card registration">
                <div className="card-body">
                  <div className="card-title">
                    <h1>Registrácia</h1>
                  </div>

                  <Tooltip>
                    <form className="k-form" onSubmit={this.handleOnRegister}>
                      <div className="k-form-field">
                        <span>Email</span>
                        <Input
                          title={titles.email}
                          type="email"
                          name="email"
                          onChange={this.handleOnChange}
                          value={email}
                          disabled
                          required
                        />
                      </div>
                      <div className="k-form-field">
                        <span>{"*Meno odberateľa"}</span>
                        <Input
                          title={titles.menoOdberatela}
                          type="text"
                          name="menoOdberatela"
                          onChange={this.handleOnChange}
                          value={menoOdberatela}
                          required
                        />
                      </div>
                      <div className="k-form-field">
                        <span>{"*Diskrétny údaj"}</span>
                        <Input
                          title={titles.diskretnyUdaj}
                          type="text"
                          name="diskretnyUdaj"
                          onChange={this.handleOnChange}
                          value={diskretnyUdaj}
                          required
                        />
                      </div>
                      <div className="k-form-field">
                        <span>{"Telefónny kontakt"}</span>
                        <Input
                          title={titles.Mobil}
                          type="tel"
                          name="Mobil"
                          onChange={this.handleOnChange}
                          placeholder="+421999999999"
                          pattern="([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)"
                          validationMessage="Nesprávny formát telefónneho čísla"
                          value={Mobil}
                        />
                      </div>

                      <div className="k-form-field">
                        <div className="footerContainer">
                          <Button
                            primary={true}
                            disabled={isLoading}
                            label="Späť"
                            onClick={this.handleOnBack}
                          />
                          <Button
                            primary={true}
                            disabled={isLoading}
                            label="Registrovať"
                            type="submit"
                          />
                        </div>
                      </div>

                      <Recaptcha
                        id="recaptcha"
                        onChange={this.handleRecaptcha}
                      />

                      {this.state.ErrText && (
                        <ErrorMsg text={this.state.ErrText} />
                      )}
                    </form>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        )}
        <CookieInfo />
        <LoadingPanel isLoading={isLoading} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading:
      state.oAuthUser.isLoading ||
      state.user.isLoading ||
      state.verifications.isLoading,
    oAuthUser: state.oAuthUser.data,
    verifyMessage: state.verifications.message,
  };
};

const mapDispatchToProps = (dispatch) => ({
  register: (userData, google = false) =>
    dispatch(registerActions.register(userData, google)),
  registerOAuth: (code, redirect_uri, provider) =>
    dispatch(oAuthActions.registerOAuth(code, redirect_uri, provider)),
  verifyEmailAndPass: (data) => dispatch(verifyActions.emailAndPass(data)),
});

Registracia.propTypes = {
  register: PropTypes.func,
  registerOAuth: PropTypes.func,
  isLoading: PropTypes.bool,
  verifyMessage: PropTypes.string,
  oAuthUser: oAuthUserPropTypes.oAuthUser,
  verifyEmailAndPass: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Registracia)
);
